// src/firebase.js
import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getStorage } from 'firebase/storage'; // ✅ add this

let app = null;
let db = null;
let auth = null;
let provider = null;
let storage = null;

/**
 * Dynamically fetch and initialize Firebase config
 * Make sure your /api/firebase-config returns:
 *   { ..., storageBucket: "panda-recipes-manager-58cb6.appspot.com", ... }
 */
export async function initializeFirebase() {
  if (getApps().length > 0) return; // already initialized

  console.log('Enter initializeFirebase 2:');
  console.log('Calling API to get FireBase Config');

  const res = await fetch('/api/firebase-config');
  if (!res.ok) throw new Error('Failed to load Firebase config');

  const firebaseConfigRemote = await res.json();
  console.log('FirebaseRemote Config: ', firebaseConfigRemote);

  // IMPORTANT: storageBucket should be the .appspot.com bucket
  // e.g. "panda-recipes-manager-58cb6.appspot.com"
  app = initializeApp(firebaseConfigRemote);
  db = getFirestore(app);
  auth = getAuth(app);
  provider = new GoogleAuthProvider();
  storage = getStorage(app); // ✅ initialize and cache Storage
}

/** Accessors to use after initializeFirebase() */
export { app, db, auth, provider, storage };
